import { PRODUCT_NAME } from '@constants';
import { toThousands } from '../../utils';

const { RETURN_ASSURANCE, RETURNABLE } = PRODUCT_NAME;

const CART_COL1_TITLE = 'Orders protected';
const CART_COL2_TITLE = 'Revenue protected';
const CART_COL3_TITLE = 'Revenue saved';
const CART_COL4_TITLE = 'Net new revenue generated';

const CART_COL1_DESC = 'Count of consumer-funded protected orders.';
const CART_COL2_DESC = 'Total monetary value of orders with protection.';
const CART_COL3_DESC = 'Total monetary value of all Seel replacements, refunds and payments.';
const CART_COL4_DESC = 'Revenue Protected * 92% (92% of surveyed Seel customers require items to be returnable to complete a purchase).';

const formatMoney = (money) => {
  if (money >= 1000000) {
    return `${(money / 1000000).toFixed(2).replace(/\.00$/, '')}M`;
  }
  if (money >= 10000) {
    return `${(money / 1000).toFixed(1).replace(/\.0$/, '')}K`;
  }
  return toThousands(money.toFixed(2).replace(/\.00$/, ''));
};
export const getDashboardData = (data, currencySymbol) => {
  // 和接口定义 netNewRevenueGenerated为null时，表示没有这一项
  const {
    ordersProtected = 0, revenueProtected = 0, revenueSaved = 0, netNewRevenueGenerated, insuranceName,
  } = data;
  const dataList = [{
    id: 1,
    title: CART_COL1_TITLE,
    desc: CART_COL1_DESC,
    dataValue: formatMoney(ordersProtected),
  }, {
    id: 2,
    title: CART_COL2_TITLE,
    desc: CART_COL2_DESC,
    dataValue: `${currencySymbol || '$'}${formatMoney(revenueProtected)}`,
  }, {
    id: 3,
    title: CART_COL3_TITLE,
    desc: CART_COL3_DESC,
    dataValue: `${currencySymbol || '$'}${formatMoney(revenueSaved)}`,
  }];
  if ([RETURN_ASSURANCE, RETURNABLE].includes(insuranceName)) {
    dataList.push({
      id: 4,
      title: CART_COL4_TITLE,
      desc: CART_COL4_DESC,
      dataValue: `${currencySymbol || '$'}${formatMoney(netNewRevenueGenerated || 0)}`,
    });
  }
  return dataList;
};
